import { Component, inject, OnInit } from '@angular/core';
import { faEdit, faPlus, faTrashAlt, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { SettlementsService } from 'src/app/services/settlements.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IconsService } from 'src/app/shared/services/icons.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-index-zone',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul app-nav-tanques [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-3">
            <div class="d-flex mb-0">
              <div class="flex-fill ms-2">
                <h2 class="mt-2 mt-md-0 mb-0">Zonas</h2>
                <p class="text-muted mb-0" style="font-size: 14px;">Configura los tanques asignados a los edificios.</p>
              </div>
            </div>
          </div>
          <div class="list-group-item table-responsive py-3">
            <div class="d-flex">
              <div class="flex-fill ms-3 me-3">
                <div class="input-group mb-0">
                  <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
                  <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                    <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                    <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                  </div>
                </div>
              </div>
              <div>
              </div>
              <div class="text-end">
                <button class="btn btn-zazz-dark ms-2 shadow-sm" routerLink="create">
                  <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                  Agregar zona
                </button>
              </div>
            </div>
          </div>
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2">Zona</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Descripción</th>
                  <th scope="col" class="text-end bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody *ngIf="zonas!.length>0">
                <tr app-tr-zonas
                  [zona]="zona" 
                  [profile]="profile" 
                  [permissions]="permissions"
                  *ngFor="let zona of zonas | paginate: { 
                    itemsPerPage: payload.per_page, 
                    currentPage: p, 
                    totalItems: meta.total_entries 
                  }"
                >
                </tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="zonas?.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="zonas?.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class IndexZoneComponent implements OnInit {
  profile: any = {};
  permissions: any = {};

  currentView: string = 'zonas';
  search: FormControl = new FormControl();

  payload: any = {
    page: 1,
    per_page: 10,
    role_id: 3
  };

  p: number = 1;

  loading: boolean = false;
  zonas: any[] = [];
  meta: any = {};
  searchBox: FormGroup = new FormGroup({});
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
  }

  ngOnInit() {    
    this.loadZonas(this.payload);

    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (!term) {
          return this.store.getZones({
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          });
        } else {
          return this.store.getZones({
            name: term, 
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          })
        }
      })).subscribe((data: any) => {
        this.zonas = data.data;
        this.meta = data.meta;
      });
  }

  loadZonas(payload: any) {
    this.loading = true;
    this.store.getZones(payload).subscribe({
      next: (zonas: any) => {
        console.log(zonas);
        this.zonas = zonas.data;
        this.meta = zonas.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.zonas = [];
        this.loading = false;
      }
    });
  }

  clearSearch() {
    delete this.payload.name;
    this.search.setValue(null);    
    this.loadZonas(this.payload);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadZonas(this.payload);
  }
}
